<div class="form-content">
  <div class="form-block">
    <app-form-field-text
      [field]="nameControl"
      label="label.name"
    ></app-form-field-text>
    <app-form-field-select
      [field]="countryControl"
      [options]="countryOptions"
      sortBy="translated-label-asc"
      label="label.country"
    ></app-form-field-select>
    <app-form-field-text
      [field]="hintControl"
      label="label.hint"
    ></app-form-field-text>
    <app-form-field-radio
      [field]="supervisionControl"
      [options]="supervisionOptions"

    >
    </app-form-field-radio>
  </div>
</div>

<div class="d-flex justify-content-between mb-3">
  <div class="d-flex">
    <button
      [routerLink]="['/home/exam-location']"
      class="btn btn-outline-primary me-3"
    >
      {{ 'button.cancel' | translate }}
    </button>
    <div class="flex-1"></div>
    <button
      (click)="delete()"
      class="btn btn-outline-danger"
    >
      {{ 'button.delete' | translate }}
    </button>
  </div>
  <button
    (click)="submit()"
    class="btn btn-primary"
  >
    {{ 'button.save' | translate }}
  </button>
</div>
